import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { PRIVACY_NOTICE as P } from "@/data/privacyNotice";
import { PRIVACY } from "@/constants/testIds/waitlist";

export const PrivacyNotice = () => {
  useEffect(() => {
    const prev = document.title;
    document.title = P.title;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div
      data-testid={PRIVACY.page}
      className="min-h-screen bg-black text-white"
    >
      <main className="mx-auto max-w-3xl px-6 sm:px-8 py-16 sm:py-24">
        <Link
          to="/"
          data-testid={PRIVACY.backLink}
          className="inline-block font-condensed uppercase tracking-[0.18em] text-xs text-[#D9B872] underline underline-offset-4 hover:text-[#E7CA86] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B872] focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded-sm"
        >
          {P.backLabel}
        </Link>

        <h1
          data-testid={PRIVACY.heading}
          className="mt-10 font-condensed uppercase font-semibold text-white text-3xl sm:text-4xl tracking-tight"
        >
          {P.heading}
        </h1>
        <p className="mt-3 text-sm text-white/55">{P.effectiveDate}</p>

        <div className="mt-8 space-y-5 text-white/80 text-base leading-relaxed">
          <p>{P.intro}</p>

          <p>{P.purposesIntro}</p>
          <ul className="list-disc pl-6 space-y-1.5 marker:text-[#C8A24C]">
            {P.purposes.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          {P.afterPurposes.map((para) => (
            <p key={para}>{para}</p>
          ))}

          <p>
            {P.contactIntro}{" "}
            <a
              href={`mailto:${P.email}`}
              data-testid={PRIVACY.emailLink}
              className="text-[#D9B872] underline underline-offset-2 break-all hover:text-[#E7CA86] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B872] focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded-sm"
            >
              {P.email}
            </a>
          </p>

          <p>{P.closing}</p>
        </div>
      </main>
    </div>
  );
};

export default PrivacyNotice;
